export const Season = {
    Fall2024: '2024 Fall' as const,
    Spring2025: '2025 Spring' as const,
    Fall2025: '2025 Fall' as const,
}
export type Season = typeof Season[keyof typeof Season]
